<template>
	<header>
		<div class="w-screen bg-primary py-1 px-4 md:px-0">
			<div class="container mx-auto flex items-center">
				<img
					class="flex-grow-0"
					:src="assetsUrl + '/logo-light.svg'"
					width="150px"
					:alt="brand"
				/>
				<div class="flex-grow text-right flex justify-end">
					<a class="btn-menu relative" href="javascript:void(0)">
						<img
							class="mx-2 cursor-pointer"
							src="@/assets/img/cuenta.svg"
							alt="Cuenta"
						/>
						<div
							id="userMenu"
							class="
								w-40
								bg-white
								absolute
								right-0
								text-left
								shadow-card
								rounded-sm
								z-50
							"
						>
							<div class="notificacion-header">
								<span class="text-13">{{
									user.name + ' ' + user.lastname
								}}</span>
							</div>
							<router-link to="/profile/">
								<div
									class="
										DropdownOption
										text-13
										OptionLink
										p-2
										item-notification
									"
								>
									{{ $t('profile') }}
								</div>
							</router-link>
							<router-link to="/profile/change_password">
								<div
									class="
										DropdownOption
										text-13
										OptionLink
										p-2
										item-notification
									"
								>
									{{ $t('change_password') }}
								</div>
							</router-link>
							<div
								class="p-2 text-13 cursor-pointer border-t item-notification"
								@click="logout"
							>
								{{ $t('logout') }}
							</div>
						</div>
					</a>
					<div>
						<router-link to="/admin/listado/noticias">
							<img
								v-if="user.role.is_administrator"
								class="mx-2 cursor-pointer"
								src="@/assets/img/admin.svg"
								alt="Admin"
							/>
						</router-link>
					</div>
					<img
						@click="revert('menuResponsive', menuResponsive)"
						class="inline w-6 md:hidden"
						src="@/assets/img/menu-hamburguesa.svg"
						alt="Cuenta"
					/>
				</div>
			</div>
		</div>
		<div
			class="
				w-screen
				bg-secondary
				py-1
				px-4
				md:px-0 md:block
				absolute
				z-40
				md:relative
			"
			:class="{ hidden: menuResponsive }"
		>
			<div class="container mx-auto flex flex-col md:flex-row md:items-center">
				<router-link to="/inicio">
					<div
						class="flex items-center mr-4 p-2 md:p-0"
						v-on:click="revert('menuResponsive', menuResponsive)"
					>
						<img class="mr-2" src="@/assets/img/inicio.svg" alt="Inicio" />
						<span class="font-light text-white">{{ $t('home') }}</span>
					</div>
				</router-link>
				<router-link to="/noticias">
					<div
						class="flex items-center mr-4 p-2 md:p-0"
						v-on:click="revert('menuResponsive', menuResponsive)"
					>
						<img class="mr-2" src="@/assets/img/noticias.svg" alt="Noticias" />
						<span class="font-light text-white">{{ $t('news') }}</span>
					</div>
				</router-link>
				<router-link to="/bonos">
					<div
						class="flex items-center mr-4 p-2 md:p-0"
						v-on:click="revert('menuResponsive', menuResponsive)"
					>
						<img class="mr-2" src="@/assets/img/bonos.svg" alt="Bonos" />
						<span class="font-light text-white">{{ $t('Bonos') }}</span>
					</div>
				</router-link>
				<a :href="filesUrl" class="p-2">
					<div
						class="flex items-center mr-4 p-2 md:p-0"
						v-on:click="revert('menuResponsive', menuResponsive)"
					>
						<img class="mr-2" src="@/assets/img/archivos.svg" alt="Archivos" />
						<span class="font-light text-white">{{ $t('drive') }}</span>
					</div>
				</a>
				<router-link to="/contactos">
					<div
						class="flex items-center mr-4 p-2 md:p-0"
						v-on:click="revert('menuResponsive', menuResponsive)"
					>
						<img
							class="mr-2"
							src="@/assets/img/contactos.svg"
							alt="Contactos"
						/>
						<span class="font-light text-white">{{ $t('Contactos') }}</span>
					</div>
				</router-link>
				<router-link to="/contratacion" v-if="user.role.allow_hiring">
					<div
						v-if="user.role.allow_hiring"
						class="flex items-center mr-4 p-2 md:p-0"
						v-on:click="revert('menuResponsive', menuResponsive)"
					>
						<img
							class="mr-2"
							src="@/assets/img/anadir-archivo.svg"
							alt="Contratacion"
						/>
						<span class="font-light text-white">{{ $t('contratacion') }}</span>
					</div>
				</router-link>
			</div>
		</div>
	</header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			brand: process.env.VUE_APP_BRAND,
			assetsUrl: process.env.VUE_APP_ASSETS_URL,
			filesUrl: process.env.VUE_APP_DRIVE_URL,
			menuResponsive: true,
			filesMenu: false,
			filesAndFolders: null,
			showAlert: false
		}
	},
	computed: {
		...mapGetters({
			user: 'login/user'
		})
	},
	methods: {
		revert(element, state) {
			this.closeAll()
			this._data[element] = !state
		},
		closeAll() {
			;(this.menuResponsive = true), (this.filesAndFoldersMenu = false)
		},
		logout() {
			this.$store.dispatch('login/logout')
		}
	}
}
</script>

<style scoped>
header .max-notif {
	max-height: 37px;
}
header .content-notif {
	max-height: 40px;
	overflow: hidden;
}
header a:hover span,
header a.router-link-active span {
	font-weight: bold;
}
header .ItemMenu:hover > #submenu,
header .ItemMenu:focus > #submenu {
	display: block;
}
header #submenu {
	display: none;
	top: 45px;
}
header #submenu div {
	padding: 5px;
}
header #submenu a {
	color: #455a64;
	font-weight: 300;
}
@media (max-width: 768px) {
	header #submenu a {
		color: white;
	}
}
header #submenu a:hover {
	color: #68ace1;
}
header .text-10 {
	font-size: 10px;
}
header .text-13 {
	font-size: 13px;
}
header .notificacion-header {
	font-weight: 700;
	color: #2d353c;
	font-size: 10px;
	background: #f2f3f4;
	padding: 10px 10px;
}
header .w-100 {
	width: 100%;
}
header .item-notification:hover {
	background: #f2f3f4;
}
header .border-item {
	border-width: 1.5px;
	border-radius: 50%;
	border-style: solid;
}

#notificationsMenu,
#userMenu {
	display: none;
}

.btn-menu:hover > #userMenu,
.btn-menu:hover > #notificationsMenu,
.btn-menu:focus > #userMenu,
.btn-menu:focus > #notificationsMenu {
	display: block;
}
a.btn-menu span {
	color: initial !important;
	text-decoration: none;
}
a.btn-menu img {
	filter: none !important;
}

.alert-danger {
	color: #721c24;
	background-color: #f8d7da;
	border-color: #f5c6cb;
	position: relative;
	padding: 0.75rem 1.25rem;
	border: 1px solid transparent;
	border-radius: 0.25rem;
}
</style>
